import React, { useMemo } from "react";
import mudrakat from "../../assets/images/team/Mudrakat.png";
import david from "../../assets/images/team/David.png";
import kikelomo from "../../assets/images/team/kikelomo.png";
import obinna from "../../assets/images/team/Obinna.png";
import tofunmi from "../../assets/images/team/tofunmi.png";
import dorothy from "../../assets/images/team/dorothy.png";
import abibat from "../../assets/images/team/abibat.png";
import susam from "../../assets/images/team/susam.png";
import "./OtherTeam.css";

// Team members data configuration
const TEAM_MEMBERS = [

  {
    id: "obinna-okoro",
    imgSrc: obinna,
    name: "Obinna Okoro",
    role: "Business Development",
    department: "Sales",
  },
  {
    id: "dorothy-onaji",
    imgSrc: dorothy,
    name: "Dorothy Onaji",
    role: "Business Development",
    department: "Sales",
  },
    {
    id: "kiklomo-ashogbon",
    imgSrc: kikelomo,
    name: "Kikelomo Ashogbon",
    role: "Technical Officer",
    department: "Operations",
  },
  {
    id: "Mudrakat-Yusuf",
    imgSrc: mudrakat,
    name: "Mudrakat Yusuf",
    role: "Technical Officer",
    department: "Operations",
  },
  {
    id: "tofunmi-sulaimon",
    imgSrc: tofunmi,
    name: "Tofunmi Sulaimon",
    role: "Graduate Trainee",
    department: "Development",
  },
  {
    id: "abibat-adeleke",
    imgSrc: abibat,
    name: "Abibat Adeleke",
    role: "Accounts Officer",
    department: "Finance",
  },
  {
    id: "susam-samson",
    imgSrc: susam,
    name: "Susam Samson",
    role: "Admin Officer",
    department: "Administration",
  },
  {
    id: "david-edet",
    imgSrc: david,
    name: "David Edet",
    role: "IT Support Officer",
    department: "Information Technology",
  },
];

/**
 * TeamMemberCard - Displays individual team member information
 * @component
 */
const TeamMemberCard = React.memo(({ member }) => {
  return (
    <div className="other-team-member-card-wrapper">
      <article className="other-team-member-card" data-member-id={member.id}>
        {/* Image Container */}
        <div className="other-team-member-image">
          <img
            src={member.imgSrc}
            alt={member.name}
            className="other-team-member-photo"
            loading="lazy"
            title={member.name}
          />
          <div className="other-team-member-overlay" />
        </div>

        {/* Content Container */}
        <div className="other-team-member-content">
          <header className="other-team-member-header">
            <h3 className="other-team-member-name">{member.name}</h3>
            <p className="other-team-member-role">{member.role}</p>
          </header>

          <footer className="other-team-member-footer">
            <span className="other-team-member-department">{member.department}</span>
          </footer>
        </div>
      </article>
    </div>
  );
});

TeamMemberCard.displayName = "TeamMemberCard";

/**
 * SectionHeader - Displays section title
 * @component
 */
const SectionHeader = () => (
  <div className="other-team-section-header" data-aos="fade-up">
    <div className="other-team-header-content">
      <h2 className="other-team-section-title">Other Team Members</h2>
    </div>
  </div>
);

/**
 * TeamGrid - Container for team member cards
 * @component
 */
const TeamGrid = ({ members }) => (
  <div className="other-team-grid-wrapper" data-aos="zoom-in">
    <div className="other-team-grid">
      {members.map((member) => (
        <TeamMemberCard key={member.id} member={member} />
      ))}
    </div>
  </div>
);

/**
 * OtherTeamMembers - Displays team members list with organized layout
 * @component
 */
const OtherTeamMembers = () => {
  const teamMembers = useMemo(() => TEAM_MEMBERS, []);

  return (
    <section className="other-team-section" aria-label="Team Members">
      <div className="other-team-container">
        <SectionHeader />
        <TeamGrid members={teamMembers} />
      </div>
    </section>
  );
};

export default OtherTeamMembers;
